import { cn } from '#/shared/lib/utils'
import { PriceSearchIcon } from '#/shared/ui/icons'

interface PriceCheckBadgeProps {
  label: string
  onClick?: () => void
  className?: string
}

function PriceCheckBadge({ label, onClick, className }: PriceCheckBadgeProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex h-6 shrink-0 cursor-pointer items-center gap-1.5 rounded pr-2 pl-0.5 text-sm font-normal text-gray-900 hover:bg-gray-100',
        className,
      )}
    >
      <PriceSearchIcon className="size-3.5 shrink-0 text-orange-500" />
      <span className="whitespace-nowrap underline">{label}</span>
    </button>
  )
}

export { PriceCheckBadge }
export type { PriceCheckBadgeProps }
